









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import Localization from '@/service/localization'

@Component({
  name: 'c-add-project-dialog'
})
export default class AddProjectDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(String) projectId!: string

  projectTitle: string = ''
  projectDescription: string = ''

  @Watch('show')
  isShowChanged (newVal: boolean) {
    if (newVal === false) {
      this.projectTitle = ''
      this.projectDescription = ''
    }
  }

  get show (): boolean {
    return this.value
  }
  set show (value: boolean) {
    this.$emit('input', value)
  }

  addProject (): void {
    Localization.addProject(this.projectTitle, this.projectDescription).then(
      res => {
        if (res == true) this.$emit("update-projects")
      }
    )
    this.show = false
  }
  cancel (): void {
    this.show = false
    this.show = false
  }
}
